import React from 'react'
import cx from 'classnames'

import getWidthClasses from './utils'

import { TComponentBase } from '../../types/componentBase'

type TWidth = 3 | 4 | 6 | 8 | 12

type TColProps = {
  width?: TWidth
  sm?: TWidth
  md?: TWidth
  lg?: TWidth
  as?: React.ElementType
  href?: string
  hasGutter?: boolean
  id?: string
}

const Col = React.forwardRef<HTMLElement, TColProps & TComponentBase>((props, ref) => {
  const className = cx(
    { 'flex-1 w-auto': !props.width },
    getWidthClasses(props),
    { 'px-8 sm:px-12 md:px-16 lg:px-24': props.hasGutter },
    props.className,
  )
  const style = { minHeight: 1, ...props.style }
  const Element = props.href ? 'a' : props.as || 'div'
  return (
    <Element id={props.id} className={className} style={style} href={props.href} ref={ref} onClick={props.onClick}>
      {props.children}
    </Element>
  )
})

Col.displayName = 'Grid.Col'

export { Col as default, TColProps, TWidth }
